import { useSyncExternalStore } from 'react';

const emptySubscribe = () => () => {};
const getIsClient = () => true;
const getIsServer = () => false;

/**
 * @returns `true` once mounted on the client; always `false` during SSR and initial hydration
 */
export function useIsClient(): boolean {
  return useSyncExternalStore(emptySubscribe, getIsClient, getIsServer);
}
